import type { ProgressTeaser } from "@/domains/progress/models/types";

export const PROGRESS_ENTRY_LINK_LABEL = "12-week journey to optimal relief";

export const PROGRESS_NAV_LABEL = "Progress";

export const PROGRESS_TEASER_TITLE = "See How Your Goals Are Trending";

/** Null means no card at all. Blank counts as absent: `body` is `z.string()`, so "" parses. */
export const selectProgressTeaserBody = (teaser: ProgressTeaser | null | undefined) => {
  const body = teaser?.body.trim() ?? "";

  return body.length > 0 ? body : null;
};

type ProgressSwitchCarrier = { progressEnabled: boolean } | null | undefined;

type ProgressTeaserCarrier =
  { progressEnabled: boolean; progressTeaser: ProgressTeaser | null } | null | undefined;

export const selectIsProgressEnabled = (carrier: ProgressSwitchCarrier) => {
  return carrier?.progressEnabled === true;
};

export const selectCareplanProgressTeaserBody = (careplan: ProgressTeaserCarrier) => {
  return selectIsProgressEnabled(careplan)
    ? selectProgressTeaserBody(careplan?.progressTeaser)
    : null;
};
